<template>
  <div>
    <form-alert :show="true" :flavour="isVM == true ? 1 : 0" :resellerId="resellerIdAsNumber">
      <p v-if="debugMakeId == 1">
          Unfortunately our partner has told us that your device has not been removed from
          <strong>Find My iPhone</strong> and they are unable to progress until this is done. Please
          <a
            href="https://support.apple.com/en-gb/guide/icloud/mmfc0eeddd/icloud"
            target="_blank"
          >Click here</a> for instructions.
       </p>
       <p v-else>
        Unfortunately our partner has told us that your device still has
        <strong>Google Account information</strong> on it and they are unable to progress until this is removed. Please
        <a
          href="https://support.google.com/accounts/answer/4533068?hl=en"
          target="_blank"
        >Click here</a> for instructions.
       </p>
       <hr />
       <p>Please let us know when you have done this by clicking the button below</p>
       <button
        v-if="!userAction"
        class="button-small"
        @click="setUserNotificationAccount"
       >I have done it!</button>
       <div v-if="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Working...</span>
        </div>
       </div>
       <span v-if="userAction && !loading && actionResult" style="font-size: 48px; color: green;">
         <i class="fas fa-check"></i>
       </span>
        <p
          v-if="userAction && !loading && !actionResult"
        >Please contact the Team by phone or email. Details can be found on the Contact Us page.</p>
    </form-alert>
  </div>
</template>

<script>
import { repairOptionsService } from "@/services/repairOptions-api.service.js";
import moment from "moment";

import FormAlert from '@/components/FormAlert.vue'

export default {
  name: "UserAccRemNotification",
  props: {
    optionWebReference: { required: true, default: null }
  },
  components: {
    FormAlert
  },
  data() {
    return {
      userAction: false,
      loading: false,
      actionResult: false,
      timer: null,

      debugMakeId: 1
    };
  },
  mounted() {},
  computed: {
    resellerId() {
      return process.env.VUE_APP_RESELLER_ID
    },
    resellerIdAsNumber() {
      const id = Number(process.env.VUE_APP_RESELLER_ID)
      if (id == 'NaN') {
        return -1
      }
      return id
    },
    isVM() {
      return process.env.VUE_APP_RESELLER_ID == 77
    }
  },
  methods: {
    async setUserNotificationAccount() {
      this.userAction = true;
      this.loading = true;
      try {
        repairOptionsService
          .setUserNotificationAccount(this.optionWebReference)
          .then(response => {
            //console.log(response);
            let { data } = response;

            this.actionResult = data;
            this.$emit("notification-success", this.actionResult);

            this.loading = false;
          })
          .catch(err => {
            console.log("setUserNotificationAccount: ", err);
          });
      } catch (err) {
        this.loading = false;
      }
    }
  },
  watch: {}
};
</script>
<style scoped>
.box {
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border: 3px solid #ccc;
  border-radius: 4px;
  background: #ffffff;
  color: black;
  width: 100%;
}
</style>
